module.exports = "/packs/media/modules/shared/components/Cookies/sections/browser-3a3bcb9361aa97704682b286654fd288.svg";